<template>
    <div>
     <v-head :title="title"></v-head>
    <div class="prowt">
        <p class="prowt_zs">您对系统有任何意见和建议，或使用中遇到的问题，请在本页面反馈。 我们会每天关注并不断优化，为您提供更好的服务！</p>
        <h4 class="prowt_bt">反馈内容</h4>
       <span class="prowt_zj">我们非常乐意收到您使用系统过程中的感受和意见！</span>
        <van-cell-group>
            <van-field
                v-model="params.name"
                placeholder="请输入反馈会员"
                readonly 
            />
            <van-field
                v-model="params.title"
                placeholder="请输入反馈标题"
            />
            <van-radio-group v-model="params.type">
                <van-radio name="1">意见建议</van-radio>
                <van-radio name="2">BUG反馈</van-radio>
                <van-radio name="3">发票问题</van-radio>
                <van-radio name="4">缴费问题</van-radio>
            </van-radio-group>
        </van-cell-group>
        <van-cell-group>
        <van-field
            v-model="params.content"
            rows="4"
            autosize
            type="textarea"
            maxlength="80"
            placeholder="请输入反馈内容"
            show-word-limit
        />
        </van-cell-group>

     </div>
        <div class="buton">
        <van-button  type="primary" @click="savePD">提交</van-button>
        </div>
    </div>
</template>

<script>
import {saveFeedBack,getCurrentAccount} from "@/api/dictionary";
import {Field,Radio,CellGroup,RadioGroup,Button,Toast} from 'vant';
import vHead from "../../components/Subhead";
import {getSessionStore} from "@/utils/sessionStorage.js"
import {mapState} from "vuex";
export default {
  data() {
    return {
        title:"问题反馈",
        params:{
            type: '1',
            name:'',
            title:'',
            content:'',
        }
    };
  },
  components: {
    vHead,
    [Field.name]:Field ,
    [Radio.name]:Radio,
    [CellGroup.name]:CellGroup,
    [RadioGroup.name]:RadioGroup,
    [Button.name]:Button,
    [Toast.name]:Toast
  },
  methods: {
  ...mapState(["userInfo"]),
    savePD(){
        if(!this.params.title){
            Toast("请输入标题");
            return false;
        }
        if(!this.params.content){
            Toast("请输入反馈内容");
            return false;
        }
        this.params.memberId = getSessionStore("memberId");
       saveFeedBack().then(res=>{
           Toast.success('提交成功');
           this.$router.push({name:"MemberCenter"});
       }) 
    }
  },
  mounted() {
      getCurrentAccount().then(res=>{
          this.params.name = res.result.name
      })
  }
};
</script>
<style scoped>
.prowt{ padding:0 4%; margin-top: 20px;}
.prowt .prowt_zs{color: #666;font-size: 14px; line-height: 1.8em;}
.prowt .prowt_bt{color: #000; margin: 20px 0; font-weight: bold; font-size:16px;}
.prowt .prowt_zj{ margin-bottom:15px; display: block; }
.buton{ width: 80%; margin: 0 auto; margin-top: 30px;}
/deep/.van-button--normal{ width: 100%; }
/deep/.prowt .el-form-item__content{ margin-left: 0 !important;}
/deep/.prowt .el-select{ width: 100%;}
/deep/.el-textarea__inner{ font-family:"Microsoft YaHei"; height: 100px;}
/deep/.van-cell{border: #ebedf0 solid 1px; margin-bottom: 15px; border-radius: 5px;}
/deep/.van-radio-group{ overflow: hidden; text-align: center; margin-top:20px;}
/deep/.van-radio{width: 40%; float: left; margin-bottom: 15px;  padding-left: 4.5%}
</style>